import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get user ID from session
const getUserId = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  return authUser.userId || 1;
};

// API to fetch restaurant bookings with optional filters and pagination
export const getRestaurantBookings = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/RestaurantBooking/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching restaurant bookings:", error);
    throw error;
  }
};

// API to insert or update a restaurant booking
export const saveRestaurantBooking = async (bookingData) => {
  try {
    const userId = getUserId();
    const response = await axios.post(
      `${BASE_URL}/api/RestaurantBooking/save?userId=${userId}`,
      bookingData,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving restaurant booking:", error);
    throw error;
  }
};
